import { COST_CENTER_ICON } from "../../../constants/icons";
import { COST_CENTER } from "../../../constants/urls";

export const Sidebar = {
  addButton: { title: "ایجاد مرکز هزینه" },
  menu: [
    { title: "لیست مراکز هزینه", icon: COST_CENTER_ICON, link: COST_CENTER }
  ]
};
